import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import StatsEliteLogo from '../brand/StatsEliteLogo';
import './Admin.css';

const AdminLayout = ({ children }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const handleLogout = () => {
        logout();
        navigate('/admin/login');
    };

    const menuItems = [
        { path: '/admin/dashboard', icon: 'fa fa-home', label: 'Dashboard' },
        { path: '/admin/analytics', icon: 'fa fa-line-chart', label: 'Analytics' },
        { path: '/admin/audit-logs', icon: 'fa fa-history', label: 'Audit Logs' },
        { path: '/admin/blog', icon: 'fa fa-pencil-square-o', label: 'Blog Posts' },
        { path: '/admin/team', icon: 'fa fa-users', label: 'Team Members' },
        { path: '/admin/services', icon: 'fa fa-cogs', label: 'Services' },
        { path: '/admin/case-studies', icon: 'fa fa-folder-open', label: 'Case Studies' },
        { path: '/admin/testimonials', icon: 'fa fa-quote-left', label: 'Testimonials' },
        { path: '/admin/contacts', icon: 'fa fa-envelope', label: 'Contact Form' },
        { path: '/admin/brochures', icon: 'fa fa-file-pdf-o', label: 'Brochures' },
    ];

    const bottomItems = [
        { path: '/admin/settings', icon: 'fa fa-gear', label: 'Settings' },
        { action: handleLogout, icon: 'fa fa-sign-out', label: 'Logout' },
    ];

    return (
        <div className="admin-container">
            {/* Header */}
            <header className="admin-header">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        style={{
                            background: 'transparent',
                            color: 'var(--text-main)',
                            border: 'none',
                            padding: '8px',
                            cursor: 'pointer',
                            marginRight: '16px',
                            fontSize: '20px'
                        }}
                    >
                        <i className="fa fa-bars"></i>
                    </button>
                    <Link to="/" className="admin-brand" aria-label="Stats Elite home">
                        <StatsEliteLogo markSize={46} wordSize={18} gap={8} />
                    </Link>
                </div>

                <div className="header-right">
                    <div className="user-profile">
                        <div className="user-info">
                            <span className="user-name">{user?.name}</span>
                            <span className="user-role">{user?.role}</span>
                        </div>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '0',
                            background: '#e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#718096'
                        }}>
                            <i className="fa fa-user"></i>
                        </div>
                    </div>
                    <button
                        onClick={handleLogout}
                        className="btn btn-logout"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            cursor: 'pointer'
                        }}
                    >
                        <i className="fa fa-sign-out"></i> Logout
                    </button>
                </div>
            </header>

            <div className="admin-wrapper">
                {/* Sidebar */}
                <aside className={`admin-sidebar ${!sidebarOpen ? 'collapsed' : ''}`}>
                    <nav className="sidebar-nav">
                        {menuItems.map((item) => {
                            const isActive = location.pathname === item.path;

                            return (
                                <div
                                    key={item.path}
                                    onClick={() => navigate(item.path)}
                                    className={`nav-item ${isActive ? 'active' : ''}`}
                                    title={!sidebarOpen ? item.label : ''}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="nav-icon">
                                        <i className={item.icon}></i>
                                    </div>
                                    <span className="nav-label">{item.label}</span>
                                </div>
                            );
                        })}
                    </nav>
                    <div className="sidebar-bottom">
                        {bottomItems.map((item) => {
                            const isActive = location.pathname === item.path;
                            const isLogout = item.label === 'Logout';

                            return (
                                <div
                                    key={isLogout ? 'logout' : item.path}
                                    onClick={() => isLogout ? item.action() : navigate(item.path)}
                                    className={`nav-item ${isActive ? 'active' : ''} ${isLogout ? 'nav-logout' : ''}`}
                                    title={!sidebarOpen ? item.label : ''}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="nav-icon">
                                        <i className={item.icon}></i>
                                    </div>
                                    <span className="nav-label">{item.label}</span>
                                </div>
                            );
                        })}
                    </div>
                </aside>

                {/* Main Content */}
                <main className="admin-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
